import SiteUnderMaintenanceIcon from 'assets/site-under-maintenance-icon';
import Button from 'components/button';
import { ButtonVariant } from 'components/button/types';
import { ROUTES } from 'shared/constants';
import RestartIcon from '../../assets/restart-icon';
import { Subheading, Heading, Wrapper, MainContent } from './styles';

const SiteUnderMaintenancePage = () => {
  return (
    <Wrapper>
      <MainContent>
        <SiteUnderMaintenanceIcon/>
        <Heading>{"Site Under Maintenance"}</Heading>
        <Subheading>{"Oops! The page you’re looking for isn’t available right now. We’re currently performing maintenance to improve your experience. Please check back soon!"}</Subheading>
        <Button
          variant={ButtonVariant.default}
          content={"Refresh page"}
          href={ROUTES.home}
          startIcon={<RestartIcon/>}
        />
      </MainContent>
    </Wrapper>
  );
};

export default SiteUnderMaintenancePage;
